import React from 'react';
import AgendaRow from './AgendaRow';
import { formatShortDateLabel, formatWeekday } from './constants';

export default function AgendaDay({ date, events, onEdit, onDelete }) {
  return (
    <div className="agenda-day space-y-2" data-date={date}>
      <div className="flex items-baseline gap-2 sticky top-0 bg-background z-10 py-1">
        <span className="agenda-day-name text-xl font-semibold text-text-main font-display">
          {formatWeekday(date)}
        </span>
        <span className="agenda-day-label text-base text-text-secondary">
          {formatShortDateLabel(date)}
        </span>
      </div>
      <div className="agenda-day-events space-y-1">
        {events.map((event) => (
          <AgendaRow
            key={event.segmentKey || event.id}
            event={event}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
}
